import { CloseIcon } from '~/components/icons'
import type { SyntheticEvent } from 'react'
import React, { useRef } from 'react'
import { Button } from '../general/Button'

type Props = {
  videoUrl: string
  onClose: () => void
}
export const VideoPlayer: React.FC<Props> = ({ videoUrl, onClose }) => {
  const backdropRef = useRef<HTMLDivElement | null>(null)
  const closeRef = useRef<HTMLButtonElement | null>(null)
  const handleCloseClick = (e: SyntheticEvent) => {
    const target: HTMLElement | null = e.currentTarget as HTMLElement
    if (
      target?.className === backdropRef.current?.className ||
      target?.className === closeRef.current?.className
    )
      onClose()
  }
  return (
    <div
      className="fixed top-0 left-0 w-dvw h-dvh z-999"
      style={{ backgroundColor: 'rgba(15,20,30,.8)' }}
      ref={backdropRef}
      onClick={handleCloseClick}
    >
      <Button
        ref={closeRef}
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0px',
          gap: '8px',
          position: 'absolute',
          width: '50px',
          height: '50px',
          top: '40px',
          right: '60px',
          borderRadius: '100px',
        }}
      >
        <CloseIcon />
      </Button>
      <div
        className="flex w-[90%] justify-center items-center p-0 gap-2 xl:w-[80%] absolute overflow-hidden top-1/2 left-1/2 rounded-[40px]"
        style={{ transform: 'translate(-50%, -50%)' }}
      >
        <video
          className="max-lg:max-w-[90%] block w-full h-auto max-xl:max-w-[450px] max-xl:my-0 max-xl:mx§-auto"
          autoPlay
          controls
          width={'30%'}
          src={videoUrl}
        />
      </div>
    </div>
  )
}
